// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '오스틴제약',
  targetSheetName: '수수료율',
  headerRowIndex: 3,
  headerRowCount: 1,
  dataStartRowIndex: 4,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '%',
  },
  // 4행 헤더가 좌·우 2블록으로 반복됨 — 행마다 2건 추출
  columnBlocks: [
    {
      drugCode: 4,
      drugName: 7,
      price: 6,
      commissionRate: 5,
    },
    {
      drugCode: 10,
      drugName: 13,
      price: 12,
      commissionRate: 11,
    },
  ],
  requiredHeaders: [
    'Class',
    'Sub Class',
    '성분명',
    '보험코드',
    '%',
    '약가',
    '제품명',
    'Class',
    '성분명',
    '보험코드',
    '%',
    '약가',
    '제품명',
  ],
});
